"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const js_cookie_1 = __importDefault(require("js-cookie"));
const api_1 = require("@app/api");
const common_1 = require("@components/common");
const Prepositions_1 = __importDefault(require("./exersices/Prepositions"));
const FakeDisinhibition_1 = __importDefault(require("./exersices/Disinhibition/FakeDisinhibition"));
const ExerciseByCheckOrderButton_1 = __importDefault(require("./exersices/ExerciseByCheckOrderButton"));
const SentenceWordOrder_1 = __importDefault(require("./exersices/SentenceWordOrder"));
const Text72_1 = __importDefault(require("./exersices/Text72"));
const CompleteSentence_1 = __importDefault(require("./exersices/CompleteSentence"));
const synonymAdapter_1 = require("./exersices/Synonym/synonymAdapter");
const LLMGeneral_1 = __importDefault(require("@app/routes/SpeechDevelopment/exersices/LLMGeneral"));
const RecognizerCardExercise_1 = __importDefault(require("@app/routes/SpeechDevelopment/components/RecognizerCardExercise"));
const FillGaps_1 = __importDefault(require("@app/routes/SpeechDevelopment/exersices/FillGaps"));
const Description = styled_components_1.default.div `
  font-family: 'GolosTextWebRegular', sans-serif;
  color: #6e77fb;
  font-size: 18px;
  padding: 15px;
  text-align: center;
  line-height: 27px;
  font-weight: 500;
  white-space: break-spaces;
  text-transform: uppercase;
`;
function isSingleWord(offer) {
    var _a;
    const w = offer.right_word.trim();
    const content = (_a = offer === null || offer === void 0 ? void 0 : offer.content) === null || _a === void 0 ? void 0 : _a.trim();
    return !/\s/.test(w) && content === '*';
}
const langMap = {
    1: 'Развитие речи',
    2: 'Speech development',
    5: 'Nutq rivojlanishi',
};
const SpeechDevelopment = () => {
    const [componentType, setComponentType] = (0, react_1.useState)('');
    const [response, setResponse] = (0, react_1.useState)(null);
    const [description, setDescription] = (0, react_1.useState)('');
    const [open, setOpen] = (0, react_1.useState)(false);
    const langId = js_cookie_1.default.get('lang_id');
    (0, react_1.useEffect)(() => {
        const rootElement = document.getElementById('ezspeech-react-front');
        const rawDescription = (rootElement === null || rootElement === void 0 ? void 0 : rootElement.getAttribute('data-short-description')) || '';
        let decodedDescription = rawDescription;
        try {
            decodedDescription = JSON.parse(`"${rawDescription}"`);
        }
        catch (e) {
            console.error(e);
        }
        setDescription(decodedDescription);
    }, []);
    (0, react_1.useEffect)(() => {
        const pathName = window.location.pathname;
        const url = new URL(pathName, window.location.origin);
        const slug = url.pathname.split('/').pop();
        api_1.ApiService.apiExercisesSpeechRetrieve(slug).then((response) => {
            setOpen(true);
            setResponse(response);
            setComponentType(response.text.text_type);
        });
        fetch('/profile/accounts/get_speed_settings')
            .then((res) => res.json())
            .then((response) => {
            localStorage.setItem('speedSettings', JSON.stringify(response));
        });
    }, []);
    const Component = (0, react_1.useMemo)(() => {
        var _a, _b;
        const shouldUseFakeDisinhibition = componentType === 'disinhibition' &&
            +langId === 2 &&
            ((_b = (_a = response === null || response === void 0 ? void 0 : response.text) === null || _a === void 0 ? void 0 : _a.offers) === null || _b === void 0 ? void 0 : _b.every((el) => isSingleWord(el)));
        const components = {
            '7.1': react_1.default.createElement(SentenceWordOrder_1.default, { response: response, description: description, langId: langId }),
            voice: react_1.default.createElement(Text72_1.default, { response: response, description: description, langId: langId }),
            '7.3': react_1.default.createElement(CompleteSentence_1.default, { response: response, description: description, langId: langId }),
            synonym: (react_1.default.createElement(RecognizerCardExercise_1.default, { exerciseParams: (0, synonymAdapter_1.mapSynonymToExerciseParams)(response), description: description })),
            '7.5': react_1.default.createElement(ExerciseByCheckOrderButton_1.default, { response: response, description: description, langId: langId }),
            disinhibition: shouldUseFakeDisinhibition || (response === null || response === void 0 ? void 0 : response.slug) === 'Mixed_Topic_Quiz' ? (react_1.default.createElement(FakeDisinhibition_1.default, { response: response, description: description, langId: langId })) : (react_1.default.createElement(RecognizerCardExercise_1.default, { exerciseParams: response, description: description, isDisinhibition: true })),
            prepositions: react_1.default.createElement(Prepositions_1.default, { response: response, description: description, langId: langId }),
            llm_general: (react_1.default.createElement(LLMGeneral_1.default, { exerciseParams: response, description: description, langId: Number(langId) })),
            text_picture_pair: (react_1.default.createElement(SentenceWordOrder_1.default, { response: response, description: description, langId: langId })),
            fill_the_gaps: (react_1.default.createElement(FillGaps_1.default, { exerciseParams: response, description: description, langId: langId })),
            voice_picture: react_1.default.createElement(Text72_1.default, { response: response, description: description, langId: langId }),
        };
        return components[componentType];
    }, [componentType, response, langId, description, isSingleWord]);
    (0, react_1.useEffect)(() => {
        if (open) {
            const handleClickOutside = () => setOpen(false);
            document.addEventListener('click', handleClickOutside);
            return () => document.removeEventListener('click', handleClickOutside);
        }
    }, [open, setOpen]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(common_1.PopUp, { title: langMap[Number(langId)] || 'Speech development', onClose: () => setOpen(false), open: open, isUseStopPropogation: false },
            react_1.default.createElement(Description, null, description)),
        Component));
};
exports.default = SpeechDevelopment;
